import React from 'react'
import axios from 'axios'
// import cn from 'classnames'
import useCountDown from 'react-countdown-hook'
// import NumberFormat from 'react-number-format'
import currency from 'currency.js'
// import NumberFormat from 'react-number-format'
// import he from 'he'
// import { format, isFuture, parse, isDate } from 'date-fns'
import { consoleLogger } from '@Utils'

// REDUX
import { useDispatch, useSelector } from 'react-redux'
import userSlice, { getUserState } from '@Slices/userSlice'
import uiSlice, { getUIState } from '@Slices/uiSlice'
// import cartSlice, { getCartState } from '@Slices/cartSlice'
// import { getGalleryState } from '@Slices/gallerySlice'

// FORMIK
// import { Formik, Form } from 'formik';
// import * as Yup from 'yup'

// COMPONENTS
import {
  Icon,
  // Table,
  Button,
  Checkbox,
  Modal,
  Grid,
  Label,
  // Form as SUIForm,
  // Dimmer,
  // Loader,
  // Popup,
  // Search,
  // Dropdown,
} from 'semantic-ui-react'
import Lottie from 'react-lottie-player'
import { TermsContent } from '@Common/Documents'

import AccountPayoutView from './AccountPayoutView'
import { toast } from 'react-toastify'
const voucher_codes = require('voucher-code-generator');

const AccountPayoutNotice = (props) => {
  const token = localStorage.Authorization
  const dispatch = useDispatch()
  const { userInfo, userKey } = useSelector(getUserState)
  const {
    handler,
    componentNameSpace,
    open,
    clearedBalance,
    fetchSales
  } = props
  
  const [ isSubmitting, setIsSubmitting ] = React.useState(false)

  const handleCashout = async () => {
    setIsSubmitting(true)
    dispatch(uiSlice.actions.updateUIComponentReady({component: componentNameSpace, isReady: false}))
    const payoutID = voucher_codes.generate({
      prefix: 'PAYOUT-',
      pattern: '################',
      postfix: `-${new Date().getFullYear()}`,
      charset: "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"
    })
    const transactionID = voucher_codes.generate({
      pattern: '################',
      charset: "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"
    })
    
    await axios({
      baseURL: process.env.REACT_APP_API_URL,
      url: `/stylefolio/v1/payout/${payoutID}`,
      method: 'POST',
      headers: {
        Authorization:`${token}`,
      },
      data: {
        author: userInfo.id,
        user_key: userKey,
        vendor_info: userInfo,
        amount: clearedBalance,
        // total_amount: clearedBalance,
        transaction_id: 'TBD',
        payout_method: userInfo.acf.payout_method,
        paypal_email: userInfo.acf.paypal_email,
      }
    }).then(res => {
      consoleLogger("CREATE PAYOUT RESPONSE ===================", res.data)
      
      toast.success(`Your payout claim request for ${currency(clearedBalance, {symbol: '$', precision: 2}).format()} has been submitted.`, {
        containerId: 'mainToaster',
        progress: undefined,
      });
      // dispatch(uiSlice.actions.setUIToast({
      //   visible: true,
      //   type: 'positive',
      //   icon: 'info circle',
      //   title: `${payoutID}`,
      //   message: `Your payout claim request for ${currency(clearedBalance, {symbol: '$', precision: 2}).format()} has been submitted.`
      // }))
    }).catch(err => {
      consoleLogger(err)
    })

    await fetchSales()
    setIsSubmitting(false)
    handler(false)
    dispatch(uiSlice.actions.updateUIComponentReady({component: componentNameSpace, isReady: true}))
  }

  const [ timeleft, { start, pause, resume, reset } ] = useCountDown(15000, 1000)
  
  React.useEffect(() => {
    start()
  }, []) // eslint-disable-line

  const lottieJson = {"v":"5.6.4","fr":60,"ip":0,"op":121,"w":280,"h":80,"nm":"avioncito","ddd":0,"assets":[],"layers":[{"ddd":0,"ind":1,"ty":3,"nm":"size wiggler","sr":1,"ks":{"o":{"a":0,"k":0,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[140,40,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ef":[{"ty":5,"nm":"Slider Control","np":3,"mn":"ADBE Slider Control","ix":1,"en":1,"ef":[{"ty":0,"nm":"Slider","mn":"ADBE Slider Control-0001","ix":1,"v":{"a":1,"k":[{"i":{"x":[0.499],"y":[1]},"o":{"x":[0.736],"y":[0]},"t":9,"s":[70]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.557],"y":[0]},"t":64,"s":[111]},{"t":111,"s":[70]}],"ix":1}}]}],"ip":0,"op":301,"st":0,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"avioncito 2","parent":3,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[2.222,0,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[111.111,111.111,100],"ix":6,"x":"var $bm_rt;\nvar temp;\ntemp = thisComp.layer('size wiggler').effect('Slider Control')('Slider');\n$bm_rt = [\n    value[0],\n    temp\n];"}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,-0.07],[-0.51,-0.3],[-0.3,0],[-0.24,0.13],[0,0],[0,0.62],[0.56,0.3],[0,0],[0.5,-0.3],[0,-0.59],[-0.03,-0.07],[0,0],[0,0]],"o":[[0,0.59],[0.26,0.16],[0.26,0],[0,0],[0.55,-0.29],[0,-0.62],[0,0],[-0.52,-0.28],[-0.51,0.31],[0,0.07],[0,0],[0,0],[-0.03,0.06]],"v":[[-10,8.33],[-9.19,9.76],[-8.33,10],[-7.57,9.81],[9.15,1.48],[10.04,0],[9.14,-1.48],[-7.56,-9.8],[-9.19,-9.76],[-10,-8.33],[-9.96,-8.12],[-6.71,0],[-9.96,8.13]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0,0],[-0.02,0],[0,0],[0,0.31],[0.31,0],[0,0],[0.02,0],[0,0],[-0.07,0.04],[-0.26,-0.14],[0,0],[0,-0.1],[0.26,-0.13],[0,0],[0.08,0.05],[0.03,0.23]],"o":[[0.02,0.01],[0,0],[0.31,0],[0,-0.31],[0,0],[-0.02,0],[0,0],[0.03,-0.23],[0.08,-0.05],[0,0],[0.27,0.14],[0,0.1],[0,0],[-0.25,0.13],[-0.07,-0.05],[0,0]],"v":[[-5.732,0.544],[-5.682,0.554],[2.238,0.554],[2.798,0.004],[2.238,-0.556],[-5.682,-0.556],[-5.732,-0.546],[-8.882,-8.416],[-8.622,-8.806],[-8.062,-8.816],[8.628,-0.486],[8.928,0.004],[8.638,0.484],[-8.072,8.824],[-8.622,8.814],[-8.882,8.424]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"mm","mm":1,"nm":"Merge Paths 1","mn":"ADBE Vector Filter - Merge","hd":false},{"ty":"fl","c":{"a":0,"k":[0,0,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[200,200],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Color","np":4,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":301,"st":0,"bm":0},{"ddd":0,"ind":3,"ty":3,"nm":"circulo 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0.7,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.124,"y":0.585},"o":{"x":0,"y":0},"t":0,"s":[-18,87,0],"to":[58,-34,0],"ti":[-59.5,2,0]},{"i":{"x":1,"y":1},"o":{"x":0.859,"y":0.403},"t":60,"s":[140,40,0],"to":[59.5,-2,0],"ti":[-58.5,-33.5,0]},{"t":120,"s":[298.5,88,0]}],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.156,0.156,0.667],"y":[1,1,1]},"o":{"x":[0.107,0.107,0.333],"y":[0,0,0]},"t":0,"s":[0,0,100]},{"i":{"x":[0.898,0.898,0.667],"y":[1,1,1]},"o":{"x":[0.859,0.859,0.333],"y":[0,0,0]},"t":60,"s":[90,90,100]},{"t":120,"s":[0,0,100]}],"ix":6}},"ao":1,"ip":0,"op":301,"st":0,"bm":0},{"ddd":0,"ind":4,"ty":4,"nm":"avioncito","parent":5,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[1.628,-0.06,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[155.111,155.111,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,-0.07],[-0.51,-0.3],[-0.3,0],[-0.24,0.13],[0,0],[0,0.62],[0.56,0.3],[0,0],[0.5,-0.3],[0,-0.59],[-0.03,-0.07],[0,0],[0,0]],"o":[[0,0.59],[0.26,0.16],[0.26,0],[0,0],[0.55,-0.29],[0,-0.62],[0,0],[-0.52,-0.28],[-0.51,0.31],[0,0.07],[0,0],[0,0],[-0.03,0.06]],"v":[[-10,8.33],[-9.19,9.76],[-8.33,10],[-7.57,9.81],[9.15,1.48],[10.04,0],[9.14,-1.48],[-7.56,-9.8],[-9.19,-9.76],[-10,-8.33],[-9.96,-8.12],[-6.71,0],[-9.96,8.13]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[200,200],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Color","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":301,"st":0,"bm":0},{"ddd":0,"ind":5,"ty":3,"nm":"circulo","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0.7,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.124,"y":0.585},"o":{"x":0,"y":0},"t":0,"s":[-18,87,0],"to":[58,-34,0],"ti":[-59.5,2,0]},{"i":{"x":1,"y":1},"o":{"x":0.859,"y":0.403},"t":60,"s":[140,40,0],"to":[59.5,-2,0],"ti":[-58.5,-33.5,0]},{"t":120,"s":[298.5,88,0]}],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.156,0.156,0.667],"y":[1,1,1]},"o":{"x":[0.107,0.107,0.333],"y":[0,0,0]},"t":0,"s":[0,0,100]},{"i":{"x":[0.898,0.898,0.667],"y":[1,1,1]},"o":{"x":[0.859,0.859,0.333],"y":[0,0,0]},"t":60,"s":[90,90,100]},{"t":120,"s":[0,0,100]}],"ix":6}},"ao":1,"ip":0,"op":301,"st":0,"bm":0},{"ddd":0,"ind":6,"ty":4,"nm":"line punteada","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[140,39.25,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-56.009,36.086],[-78.5,-50.5]],"o":[[74.5,-48],[85.444,54.967]],"v":[[-136.5,38],[136.75,37.75]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":3,"ix":5},"lc":2,"lj":2,"bm":0,"d":[{"n":"d","nm":"dash","v":{"a":0,"k":13.7,"ix":1}},{"n":"o","nm":"offset","v":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[0]},{"t":240,"s":[-109.7]}],"ix":7}}],"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":301,"st":0,"bm":0}],"markers":[]}

  return (
          <Modal
            onClose={() => handler(false)}
            onOpen={() => handler(true)}
            open={open}
            dimmer={{
                blurring: true
            }}
            size='tiny'
            closeOnDimmerClick={!isSubmitting}
          >
            <>
              <Modal.Header>{!isSubmitting ? 'Terms of Service' : 'Processing Payout...'}</Modal.Header>
              <Modal.Content scrolling>
                <Modal.Description>
                  {!isSubmitting ?
                    <>
                      <TermsContent />
                    </> : 
                    <>
                      <Lottie
                        loop
                        animationData={lottieJson}
                        play
                        style={{ width: '100%', height: 80 }}
                      />
                    </>
                  }
                </Modal.Description>
              </Modal.Content>
              <Modal.Actions>
                <Button
                  type='button'
                  content="Cancel"
                  labelPosition='right'
                  icon='close'
                  onClick={() => handler()}
                  basic
                  disabled={isSubmitting}
                />
                {timeleft === 0 ?
                  <Button
                    type='submit'
                    content={`I Agree`}
                    labelPosition='right'
                    icon={`check`}
                    onClick={() => handleCashout()}
                    positive
                    loading={isSubmitting}
                    disabled={isSubmitting}
                  /> : 
                  <Button
                    type='submit'
                    content={`I Agree`}
                    labelPosition='right'
                    label={`${timeleft/1000}s`}
                    positive
                    disabled
                  />
                }
              </Modal.Actions>
            </>
          </Modal>
  )
}

export default React.memo(AccountPayoutNotice)